'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { ResponsiveImage } from '@susu/headless-commerce/components/ResponsiveImage/ResponsiveImage'
import type { DeviceName } from '@susu/headless-commerce/components/ResponsiveImage/ResponsiveImage.types'
import styles from '@susu/headless-commerce/features/configurator/components/Preview/Preview.module.scss'
import { configuratorSignal } from '@susu/headless-commerce/features/configurator/signals/configurator'
import { useResizeObserver } from '@susu/headless-commerce/hooks/useResizeObserver'
import { isUndefined } from '@susu/undefined'
import classNames from 'classnames'

export const imageSourcesetSizes = {
  xs: '100vw',
  md: '100vw',
  lg: '70vw',
}

// TODO: Hardcoded
const imageTestId = 'bowtie-image'
const imageAlt = 'Configurator - Preview'
const imageLazyloading = false

export type StaticImageSources = Record<DeviceName, string>

export const ClientPreview = () => {
  useSignals()

  // TODO: Move all of this into the model.
  const configurator = configuratorSignal.value
  const previewData = configurator.preview.value.previewData.value

  if (isUndefined(configurator.currentStep.value)) {
    throw new Error('ClientPreview: No current step')
  }

  const isLayered = configurator.currentStep.value.isLayered()
  const imageSrc = isLayered
    ? configurator.preview.value.imageURL.value
    : previewData.staticImage.value?.desktop
      ? previewData.staticImage.value?.desktop
      : ''
  const imageSourceSets = configurator.preview.value.imageSourceSets.value
  const imageDesktopSrcSet = isLayered
    ? imageSourceSets.desktopSrcSet.value
    : previewData.staticImage.value?.desktop
      ? previewData.staticImage.value?.desktop
      : ''
  const imageMobileSrcSet = isLayered
    ? imageSourceSets.mobileSrcSet.value
    : previewData.staticImage.value?.mobile
      ? previewData.staticImage.value?.mobile
      : ''
  const imageTabletSrcSet = isLayered
    ? imageSourceSets.tabletSrcSet.value
    : previewData.staticImage.value?.tablet
      ? previewData.staticImage.value?.tablet
      : ''

  const previewWrapperClassnames = classNames(
    styles['preview-wrapper'],
    styles[`preview-type-${isLayered ? 'layered' : 'static'}`],
  )

  // TODO: Hardcoded value
  const imageClassnames = classNames(
    configurator.currentStep.value?.name.value === 'bow-tie' ||
      configurator.currentStep.value?.name.value === 'shirt'
      ? styles['preview-type-layered-bowtieimage']
      : '',
  )

  useResizeObserver(() => {
    if (isUndefined(configurator.currentStep.value)) {
      throw new Error('ClientPreview: No current step')
    }
    configurator.preview.value.updateLayeredPreviewPosition(
      configurator.currentStep.value,
    )
  })

  return (
    <div className={styles.preview}>
      <div className={previewWrapperClassnames}>
        <ResponsiveImage
          alt={imageAlt}
          className={imageClassnames}
          data-testid={imageTestId}
          desktopSizes={imageSourcesetSizes.lg}
          desktopSrcSet={imageDesktopSrcSet}
          lazyloading={imageLazyloading}
          mobileSizes={imageSourcesetSizes.xs}
          mobileSrcSet={imageMobileSrcSet}
          src={imageSrc}
          tabletSizes={imageSourcesetSizes.md}
          tabletSrcSet={imageTabletSrcSet}
        />
      </div>
    </div>
  )
}
